import { JsonProperty, ObjectMapper } from 'json-object-mapper';
import { IModel } from '../IModel';
import { Model } from '../model';

export class RecruitmentReassignmentPreviewModel
  extends Model
  implements IModel<RecruitmentReassignmentPreviewModel>
{
  @JsonProperty()
  public targetJobTitle: string = '';

  @JsonProperty()
  public expireDateUtc: string = '';

  @JsonProperty()
  public targetDescription: string | null = null;

  @JsonProperty()
  public targetResponsabilities: string | null = null;

  @JsonProperty()
  public targetTechnicalRequirements: string | null = null;

  @JsonProperty()
  public targetBehavioralRequirements: string | null = null;

  @JsonProperty()
  public targetBenefits: string | null = null;

  static create(input: any): RecruitmentReassignmentPreviewModel {
    return ObjectMapper.deserialize<RecruitmentReassignmentPreviewModel>(
      RecruitmentReassignmentPreviewModel,
      input ?? {}
    );
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }
}
